import { sfAnd, sfEqual, sfOr } from 'spring-filter-query-builder';
import { escapeSfqbString } from '../sfqb';
import { sfLike } from './sfqb';

export const makeEgroupDefaultFilter = (searchParam: string): string =>
    sfAnd([sfEqual('isActive', 'true'), sfLike('name', `${escapeSfqbString(searchParam, true)}*`, true)]).toString();

export const makeMeetingsDefaultFilter = (searchParam: string): string =>
    sfOr([
        sfLike('labelEn', `${escapeSfqbString(searchParam, true)}*`, true),
        sfLike('labelFr', `${escapeSfqbString(searchParam, true)}*`, true),
    ]).toString();

export const makeSensorsDefaultFilter = (searchParam: string): string =>
    sfLike('sensorName', `${escapeSfqbString(searchParam, true)}*`, true).toString();

export const makeContractsDefaultFilter = (searchParam: string): string =>
    sfOr([
        sfLike('contractNumber', `${escapeSfqbString(searchParam, true)}*`, true),
        sfLike('employer.name', `${escapeSfqbString(searchParam, true)}*`, true),
        sfLike('cernContractResponsible.searchLabel', `${escapeSfqbString(searchParam, true)}*`, true),
    ]).toString();

export const makeWorkOrdersDefaultFilter = (searchParam: string): string =>
    sfLike('id', `${escapeSfqbString(searchParam, true)}*`, true).toString();
